
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";

export function ViewContainer(props) {
    return reactElement("div", {
        "data-test-id": "view-container",
        className: join(" ", ["bg-background", "px-7", "pb-5", "pt-7", "overflow-auto", "h-full"]),
        children: reactApi.Children.toArray([props.Children]),
    });
}

